import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

const isValidUrl = (url: string) => {
    try {
        new URL(url);
        return true;
    } catch {
        return false;
    }
};

export const supabase = isValidUrl(supabaseUrl)
    ? createClient(supabaseUrl, supabaseKey)
    : createClient('https://placeholder-url.supabase.co', 'placeholder-key');